import { logger } from '@fiverr-private/obs';
import { isBrowser } from '../utils';
import { CodeActivationTriggerArgs } from '../types';
import { globalGrafanaReporter } from '../events';
import { EVENTS, EMITTER_TIMEOUT } from './constants';
import { codeActivationEventBus } from './codeActivationEventBus';

export const openCodeActivationModal = (payload: CodeActivationTriggerArgs) =>
    new Promise<void>((resolve, reject) => {
        {
            try {
                globalGrafanaReporter.count('identification.%{platform}.activation.open_code_activation_modal.start');

                if (!isBrowser()) {
                    throw new Error(
                        '[Code Activation] Cannot open modal on server side - browser environment required'
                    );
                }

                const event = {
                    event: EVENTS.SHOW_CODE_ACTIVATION_MODAL,
                    args: payload,
                };

                codeActivationEventBus.emit(event.event, event.args);

                const hasRegisteredListener = codeActivationEventBus.log.findLast(
                    ({ event }) => event === EVENTS.REGISTER_CODE_ACTIVATION_LISTENER
                );

                if (hasRegisteredListener) {
                    globalGrafanaReporter.count(
                        'identification.%{platform}.activation.open_code_activation_modal.success'
                    );

                    resolve();
                } else {
                    const timeoutId = setTimeout(() => {
                        codeActivationEventBus.off(EVENTS.REGISTER_CODE_ACTIVATION_LISTENER);
                        const error = new Error(
                            `[Code Activation] Modal failed to initialize within ${EMITTER_TIMEOUT}ms - listener not registered`
                        );

                        globalGrafanaReporter.count(
                            'identification.%{platform}.activation.open_code_activation_modal.failed'
                        );

                        logger.warn('[Code Activation] Failed to open modal', {
                            error,
                            payload,
                        });

                        reject(error);
                    }, EMITTER_TIMEOUT);

                    codeActivationEventBus.once(EVENTS.REGISTER_CODE_ACTIVATION_LISTENER, () => {
                        clearTimeout(timeoutId);

                        globalGrafanaReporter.count(
                            'identification.%{platform}.activation.open_code_activation_modal.success'
                        );

                        resolve();
                    });
                }
            } catch (error) {
                globalGrafanaReporter.count('identification.%{platform}.activation.open_code_activation_modal.failed');

                logger.warn('[Code Activation] Failed to open modal', {
                    error: error instanceof Error ? error.message : 'Unknown error',
                    payload,
                });

                reject(error);
            }
        }
    });
